import React from 'react';
import { 
  Box, 
  Card, 
  Typography, 
  Grid, 
  IconButton,
  CardActionArea,
  CardContent,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Палитра схем — 2 цвета из темы приложения
const C = {
  primary: '#d32f2f',       // Красный ProxyTherm — основная труба / подача
  primaryLight: '#212121',  // Бледно-красный — обратка / вторичные трубы
  dark: '#424242',          // Тёмно-серый — контуры, детали
  muted: '#9e9e9e',         // Серый — заглушки, второстепенные элементы
  cap: '#bdbdbd',           // Светло-серый — торцевые заглушки (прямоугольники)
};

/**
 * SVG превью для разных типов изделий
 */
const SchematicPreview = ({ type }) => {
  switch (type) {
    case 'hydraulic_separator':
      // Гидравлический разделитель — вертикальная труба с 4 боковыми подключениями
      return (
        <svg viewBox="0 0 200 200" style={{ width: '100%', height: '100%' }}>
          {/* Верхняя заглушка */}
          <rect x="91" y="22" width="18" height="7" fill={C.cap} rx="2" />
          {/* Нижняя заглушка */}
          <rect x="91" y="171" width="18" height="7" fill={C.cap} rx="2" />

          {/* Основная труба — верхняя половина подача, нижняя обратка */}
          <rect x="91" y="29" width="18" height="71" fill={C.primary} rx="2" />
          <rect x="91" y="100" width="18" height="71" fill={C.primaryLight} rx="2" />

          {/* Левые подключения — подача (сверху) и обратка (снизу) */}
          <line x1="91" y1="72" x2="32" y2="72" stroke={C.primary} strokeWidth="3" strokeLinecap="round" />
          <line x1="91" y1="128" x2="32" y2="128" stroke={C.primaryLight} strokeWidth="3" strokeLinecap="round" />

          {/* Правые подключения */}
          <line x1="109" y1="72" x2="168" y2="72" stroke={C.primary} strokeWidth="3" strokeLinecap="round" />
          <line x1="109" y1="128" x2="168" y2="128" stroke={C.primaryLight} strokeWidth="3" strokeLinecap="round" />

        </svg>
      );

    case 'distribution_collector':
      // Распределительный коллектор — две горизонтальные гребёнки + контуры
      // supplyY=70, returnY=130. Длинный патрубок доходит до другой трубы, короткий — только от своей.
      return (
        <svg viewBox="0 0 200 200" style={{ width: '100%', height: '100%' }}>
          {/* Левые заглушки */}
          <rect x="18" y="67" width="7" height="8" fill={C.cap} rx="0.5" />
          <rect x="18" y="127" width="7" height="8" fill={C.cap} rx="0.5" />
          {/* Правые заглушки */}
          <rect x="175" y="67" width="7" height="8" fill={C.cap} rx="0.5" />
          <rect x="175" y="127" width="7" height="8" fill={C.cap} rx="0.5" />

          {/* Подающий коллектор (верхний) supplyY=70 */}
          <line x1="29" y1="70" x2="171" y2="70" stroke={C.primary} strokeWidth="8" strokeLinecap="round" />

          {/* Обратный коллектор (нижний) returnY=130 */}
          <line x1="29" y1="130" x2="171" y2="130" stroke={C.primaryLight} strokeWidth="8" strokeLinecap="round" />

          {/* Контур 1
              Подача: короткий(x=62) 70→65; длинный(x=72) 130→65 (доходит до обратки)
              Обратка: длинный(x=62) 70→135 (доходит до подачи); короткий(x=72) 130→135 */}
          <line x1="62" y1="50" x2="62" y2="65" stroke={C.primary} strokeWidth="1.2" />
          <line x1="72" y1="130" x2="72" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="62" y1="75" x2="62" y2="150" stroke={C.dark} strokeWidth="1.2" />
          <line x1="72" y1="130" x2="72" y2="150" stroke={C.dark} strokeWidth="1.2" />

          {/* Контур 2 */}
          <line x1="96" y1="50" x2="96" y2="65" stroke={C.primary} strokeWidth="1.2" />
          <line x1="106" y1="130" x2="106" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="96" y1="75" x2="96" y2="150" stroke={C.dark} strokeWidth="1.2" />
          <line x1="106" y1="130" x2="106" y2="150" stroke={C.dark} strokeWidth="1.2" />

          {/* Контур 3 */}
          <line x1="130" y1="50" x2="130" y2="65" stroke={C.primary} strokeWidth="1.2" />
          <line x1="140" y1="130" x2="140" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="130" y1="75" x2="130" y2="150" stroke={C.dark} strokeWidth="1.2" />
          <line x1="140" y1="130" x2="140" y2="150" stroke={C.dark} strokeWidth="1.2" />
        </svg>
      );

    case 'collector_with_separator':
      // Коллектор с гидравлическим разделителем
      return (
        <svg viewBox="0 0 200 200" style={{ width: '100%', height: '100%' }}>
          {/* Заглушки разделителя */}
          <rect x="14" y="15" width="11" height="7" fill={C.cap} rx="2" />
          <rect x="14" y="178" width="11" height="7" fill={C.cap} rx="2" />

          {/* Гидравлический разделитель — верхняя половина подача, нижняя обратка */}
          <rect x="16" y="22" width="7" height="78" fill={C.primary} rx="1" />
          <rect x="16" y="100" width="7" height="78" fill={C.primaryLight} rx="1" />

          {/* Левые подключения разделителя */}
          <line x1="16" y1="68" x2="-15" y2="68" stroke={C.primary} strokeWidth="2.5" strokeLinecap="round" />
          <line x1="16" y1="132" x2="-15" y2="132" stroke={C.primaryLight} strokeWidth="2.5" strokeLinecap="round" />

          {/* Подающий коллектор */}
          <rect x="23" y="63" width="155" height="10" fill={C.primary} rx="2" />
          {/* Правая заглушка подачи */}
          <rect x="178" y="63" width="7" height="10" fill={C.cap} rx="2" />

          {/* Обратный коллектор */}
          <rect x="23" y="127" width="155" height="10" fill={C.primaryLight} rx="2" />
          {/* Правая заглушка обратки */}
          <rect x="178" y="127" width="7" height="10" fill={C.cap} rx="2" />

          {/* Контур 1
              Подача supplyY=68: короткий(x=58) 68→63; длинный(x=66) 132→63 (доходит до обратки)
              Обратка returnY=132: длинный(x=58) 68→137 (доходит до подачи); короткий(x=66) 132→137 */}
          <line x1="58" y1="68" x2="58" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="66" y1="127" x2="66" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="58" y1="74" x2="58" y2="150" stroke={C.dark} strokeWidth="1.2" />
          <line x1="66" y1="150" x2="66" y2="137" stroke={C.dark} strokeWidth="1.2" />

          {/* Контур 2 */}
          <line x1="100" y1="68" x2="100" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="108" y1="127" x2="108" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="100" y1="74" x2="100" y2="150" stroke={C.dark} strokeWidth="1.2" />
          <line x1="108" y1="150" x2="108" y2="137" stroke={C.dark} strokeWidth="1.2" />

          {/* Контур 3 */}
          <line x1="142" y1="68" x2="142" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="150" y1="127" x2="150" y2="50" stroke={C.primary} strokeWidth="1.2" />
          <line x1="142" y1="74" x2="142" y2="150" stroke={C.dark} strokeWidth="1.2" />
          <line x1="150" y1="150" x2="150" y2="137" stroke={C.primaryLight} strokeWidth="1.2" />
        </svg>
      );

    case 'floor_collector':
      // Этажный коллектор — одна горизонтальная гребёнка с верхними и нижними отводами
      return (
        <svg viewBox="0 0 200 200" style={{ width: '100%', height: '100%' }}>
          {/* Левая заглушка */}
          <rect x="18" y="93" width="8" height="14" fill={C.cap} rx="2" />
          {/* Правая заглушка */}
          <rect x="174" y="93" width="8" height="14" fill={C.cap} rx="2" />

          {/* Основная труба (гребёнка) */}
          <rect x="26" y="94" width="148" height="12" fill={C.primary} rx="2" />
          {/* Блик */}
          <rect x="28" y="96" width="144" height="3" fill="white" opacity="0.2" rx="1" />

          {/* Верхние отводы (подача) */}
          <line x1="55" y1="94" x2="55" y2="50" stroke={C.dark} strokeWidth="3" strokeLinecap="round" />

          <line x1="83" y1="94" x2="83" y2="50" stroke={C.dark} strokeWidth="3" strokeLinecap="round" />

          <line x1="117" y1="94" x2="117" y2="50" stroke={C.dark} strokeWidth="3" strokeLinecap="round" />

          <line x1="145" y1="94" x2="145" y2="50" stroke={C.dark} strokeWidth="3" strokeLinecap="round" />

        </svg>
      );

    default:
      return null;
  }
};

/**
 * Типы изделий для автоконструктора
 */
const productTypes = [
  {
    id: 'hydraulic_separator',
    name: 'Гидравлический разделитель',
    description: 'Устройство для гидравлической развязки контуров отопления',
  },
  {
    id: 'distribution_collector',
    name: 'Распределительный коллектор',
    description: 'Коллектор для распределения теплоносителя по контурам',
  },
  {
    id: 'collector_with_separator',
    name: 'Коллектор с гидравлическим разделителем',
    description: 'Комбинированное решение: разделитель + распределительный коллектор',
  },
  {
    id: 'floor_collector',
    name: 'Этажный коллектор',
    description: 'Простой коллектор для поэтажной разводки отопления',
  },
];

/**
 * Меню выбора типа изделия для автоматического конструктора
 */
function AutoConstructorMenu({ onSelectType, onBack }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f5f5 0%, #ffffff 50%, #fafafa 100%)',
        py: 4,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Красная полоска сверху */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          background: 'linear-gradient(90deg, #d32f2f 0%, #e53935 50%, #d32f2f 100%)',
        }}
      />
      
      <Box sx={{ width: '100%', px: 3, display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ maxWidth: '75rem', width: '100%' }}> {/* 1200px */}
          {/* Шапка с кнопкой назад */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
            <IconButton
              onClick={onBack}
              sx={{
                mr: 2,
                bgcolor: 'white',
                border: '0.0625rem solid #e0e0e0', // 1px
                boxShadow: 'none',
                '&:hover': { 
                  bgcolor: '#f5f5f5',
                  border: '0.0625rem solid #d0d0d0',
                },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 600, color: '#212121' }}>
                Автоматический конструктор
              </Typography>
              <Typography color="text.secondary">
                Выберите тип изделия для генерации чертежа
              </Typography>
            </Box>
          </Box>

          {/* Карточки выбора типа */}
          <Grid container spacing={3}>
            {productTypes.map((type) => (
              <Grid item xs={12} sm={6} key={type.id}>
                <Card
                  sx={{
                    height: '100%',
                    background: '#ffffff',
                    borderRadius: 4, // 4px (фиксированное значение для визуального скругления)
                    transition: 'all 0.3s ease',
                    border: '0.125rem solid #e0e0e0', // 2px
                    boxShadow: '0 0.25rem 0.75rem rgba(0,0,0,0.08)', // 0 4px 12px
                    '&:hover': {
                      transform: 'translateY(-0.5rem)', // -8px
                      boxShadow: '0 1.25rem 2.5rem rgba(211,47,47,0.15)', // 0 20px 40px
                      border: '0.125rem solid #d32f2f',
                    },
                  }}
                >
                  <CardActionArea
                    onClick={() => onSelectType(type.id)}
                    sx={{ height: '100%', p: 2 }}
                  >
                    <CardContent>
                      {/* Схема-превью */}
                      <Box
                        sx={{
                          height: '9.375rem', // 150px
                          background: 'linear-gradient(145deg, #fff8f8 0%, #fff5f5 100%)',
                          borderRadius: 2,
                          mb: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '0.0625rem solid #fce4e4',
                          p: 1,
                        }}
                      >
                        <SchematicPreview type={type.id} />
                      </Box>

                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: '#212121' }}>
                        {type.name}
                      </Typography>
                      <Typography color="text.secondary" variant="body2" sx={{ lineHeight: 1.5 }}>
                        {type.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default AutoConstructorMenu;

